/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AgentFeedbackInput, EntityId } from "./data-contracts";

/**
 * @description Submit structured feedback from an AI agent about an MCP tool or operation, a CLI command, an API endpoint, a site page/mcp, or the product overall. The site collects and owns the feedback rather than being its subject.
 * @tags site-agent-feedback
 * @name SubmitAgentFeedbackToSite
 * @summary Submit agent feedback
 * @request POST:/orgs/{organizationId}/sites/{siteId}/agents/feedback
 * @secure
 */

// @ts-ignore
export const submitAgentFeedbackToSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: AgentFeedbackInput;
  RequestHeaders: {};
  ResponseBody: {
    /** Unique identifier of the submission. */
    id: string;
    /** Message relayed back to the agent, acknowledging the feedback and telling it what happens next. */
    result: string;
  };
  ResponseStatusCode: 201 | 400 | 403;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/agents/feedback",
  method: "post",
  streaming: false,
  tags: ["site-agent-feedback"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
